import { useFilterStore } from "@faire/deprecated-retailer-visitor-shared/components/Filters/useFilterStore";
import { useGetItemsPerRowResponsive } from "@faire/deprecated-retailer-visitor-shared/components/SearchProducts/utils";
import { SEARCH_PRODUCT_TRACK_CLICK_CONTAINER_NAME } from "@faire/deprecated-retailer-visitor-shared/services/consts";
import { useSearchPageFilterKeys } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageResults/__internal__/SearchPageProductResults/__internal__/useSearchPageFilterKeys";
import { useSearchPageBrandMap } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageBrandMap";
import { useSearchPageProductTokens } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageProductTokens";
import { useSearchPageQueryIsLoading } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageQueryIsLoading";
import { useSearchPageRequestId } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageRequestId";
import { useSearchPageIsFromDiscoverURL } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";
import { useSearchPageProductSearchString } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { useSearchPageZeroIndexedPageNumber } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageZeroIndexedPageNumber";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { SearchProductsResultsList } from "@faire/deprecated-retailer-visitor-shared/views/search/__internal__/SearchProductsPage/__internal__/SearchProductsResultsList";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import { IQueryProductsV2WithLeanTileResponse } from "@faire/web-api--source/indigofair/data/IQueryProductsV2WithLeanTileResponse";
import { ProductTileContainer } from "@faire/web-api--source/indigofair/data/ProductTileContainer";
import { ProductTileScreen } from "@faire/web-api--source/indigofair/data/ProductTileScreen";
import { ProductTileScreenContainer } from "@faire/web-api--source/indigofair/data/ProductTileScreenContainer";
import { useTraceComponentRender } from "@faire/web/common/tracing/useTraceComponentRender";
import React from "react";

interface IProps {
  title: string;
  products: ILeanProductTile[] | undefined;
  irrelevantProducts: ILeanProductTile[] | undefined;
  organicRelevanceClassification?: keyof typeof IQueryProductsV2WithLeanTileResponse.OrganicRelevanceClassification;
  searchPageLoadTimingRef?: React.Ref<HTMLDivElement>;
  brandMap?: Partial<Record<string, ILeanProductTile.IBrand>>;
  requestId?: string;
}

export const SearchPageExactProductResults: React.FC<IProps> = ({
  title,
  products,
  irrelevantProducts,
  organicRelevanceClassification,
  searchPageLoadTimingRef,
  brandMap,
  requestId,
}) => {
  useTraceComponentRender("SearchPageExactProductResults");

  const {
    data: { isSideBarVisible },
  } = useFilterStore(["isSideBarVisible"]);

  const isFromDiscoverURL = useSearchPageIsFromDiscoverURL();
  const loading = useSearchPageQueryIsLoading();
  const searchBrandMap = useSearchPageBrandMap();
  const productSearchString = useSearchPageProductSearchString();
  const filterKeys = useSearchPageFilterKeys();
  const pageNumber = useSearchPageZeroIndexedPageNumber();
  const searchPageRequestId = useSearchPageRequestId();
  const productTokens = useSearchPageProductTokens();

  const itemsPerRowResponsive = useGetItemsPerRowResponsive(isSideBarVisible);

  return (
    <SearchProductsResultsList
      isFromDiscoverURL={isFromDiscoverURL}
      title={title}
      products={loading ? undefined : products}
      irrelevantProducts={loading ? undefined : irrelevantProducts}
      organicRelevanceClassification={organicRelevanceClassification}
      productTokens={productTokens}
      isLoading={loading}
      brandMap={brandMap ?? searchBrandMap}
      containerName={`${SEARCH_PRODUCT_TRACK_CLICK_CONTAINER_NAME}_old`}
      productTileContainer={ProductTileContainer.SEARCH_PRODUCT_RESULTS_GRID}
      queryString={productSearchString}
      filterKeys={filterKeys}
      pageNumber={pageNumber + 1}
      requestId={requestId ?? searchPageRequestId}
      itemsPerRowResponsive={itemsPerRowResponsive}
      searchPageLoadTimingRef={searchPageLoadTimingRef}
      productTileScreen={ProductTileScreen.SEARCH_PRODUCT_RESULTS}
      productTileScreenContainer={
        ProductTileScreenContainer.SEARCH_PRODUCT_RESULTS_PRIMARY_RESULTS
      }
    />
  );
};
